import script from "./DetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailPage.vue?vue&type=script&setup=true&lang=js"

import "./DetailPage.vue?vue&type=style&index=0&id=cfc04d68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfc04d68"]])

export default __exports__